export const REQUEST_WORK_EMAIL_VERIFICATION_REQUEST = 'REQUEST_WORK_EMAIL_VERIFICATION_REQUEST';
export const REQUEST_WORK_EMAIL_VERIFICATION_SUCCESS = 'REQUEST_WORK_EMAIL_VERIFICATION_SUCCESS';
export const REQUEST_WORK_EMAIL_VERIFICATION_FAILURE = 'REQUEST_WORK_EMAIL_VERIFICATION_FAILURE';
export const GET_ORGANISATIONS_REQUEST = 'GET_ORGANISATIONS_REQUEST';
export const GET_ORGANISATIONS_SUCCESS = 'GET_ORGANISATIONS_SUCCESS';
export const GET_ORGANISATIONS_FAILURE = 'GET_ORGANISATIONS_FAILURE';
export const VERIFYING_EMPLOYER_BENEFIT = 'VERIFYING_EMPLOYER_BENEFIT';
export const REDEEM_EMPLOYER_BENEFIT_REQUEST = 'REDEEM_EMPLOYER_BENEFIT_REQUEST';
export const REDEEM_EMPLOYER_BENEFIT_SUCCESS = 'REDEEM_EMPLOYER_BENEFIT_SUCCESS';
export const REDEEM_EMPLOYER_BENEFIT_FAILURE = 'REDEEM_EMPLOYER_BENEFIT_FAILURE';
export const GET_EMPLOYER_BENEFIT_ELIGIBILITY_REQUEST = 'GET_EMPLOYER_BENEFIT_ELIGIBILITY_REQUEST';
export const GET_EMPLOYER_BENEFIT_ELIGIBILITY_SUCCESS = 'GET_EMPLOYER_BENEFIT_ELIGIBILITY_SUCCESS';
export const GET_EMPLOYER_BENEFIT_ELIGIBILITY_FAILURE = 'GET_EMPLOYER_BENEFIT_ELIGIBILITY_FAILURE';
